import { ClaudeTemplate } from "../types";

/** Spotify Ads Manager (antes Ad Studio): audio, vídeo y display en Spotify y podcasts. */
export const spotifyAdsTemplate: ClaudeTemplate = {
  id: "spotify-ads",
  tool: "Spotify Ads Manager",
  url: "https://ads.spotify.com/ (botón de acceso a Ads Manager; antes se llamaba Ad Studio)",
  hierarchy: "Ad account → Campaign → Ad set → Ads",
  idHint:
    "ID de la campaña que aparece en la URL al abrirla o en el detalle de la campaña",
  accountField: "spotifyAdAccountIds",
  steps: `
### 1. Entrar en la cuenta (puede que ya estés dentro)
1. Abre Spotify Ads Manager ({{url}}). Si ya está abierto, sigue.
2. Elige la **Ad account** del cliente {{client}}. ID(s) conocidos: {{accountIds}}. Si no hay ID, búscala por nombre; si hay varias, pregunta.

### 2. Campaign
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 3.
2. Si no existe, créala:
   - Name: {{names.order}}
   - Objective: el que encaje con {{goal.kpi}} (CPM → Reach / Awareness; CPC → Clicks / Traffic; CPV → Video views; CPL/CPA → el de conversiones si existe).

### 3. Ad set
1. Crea un ad set:
   - Name: {{names.line}}
   - Formato: según el tipo {{campaignType}} (AUDIO / AUDIO_DIGITAL → audio; VIDEO → vídeo; DISPLAY → display). Si el tipo es de podcast, elige el inventario de podcasts.
   - Fechas: {{goal.startDate}} → {{goal.endDate}}.
   - Budget: {{goal.budget}} (total del periodo, no diario, si se puede elegir).
   - Puja / coste objetivo: en torno a {{goal.netUnitCost}} si la herramienta lo permite.
2. Audiencia:
   - Ubicación: {{target.geography}} (país {{goal.country}}).
   - Edad: {{target.age}}. Sexo: {{target.gender}}. Idioma: {{target.language}}.
   - Intereses / contextos / géneros musicales: {{target.interests}}.
   - Audiencias propias: {{target.audience}}.
   - Plataformas / dispositivos: {{target.technology}}.
3. Guarda sin activar.

### 4. Ads
1. Crea el anuncio con nombre {{names.line}}.
2. Sube las piezas del bloque "Creatividades" (audio, vídeo o imagen de acompañamiento). Si el audio no existe y la herramienta ofrece generarlo con voz, no lo hagas sin preguntar.
3. Texto / tagline y CTA: bloque "Copies". URL de destino con UTM: bloque "URLs de destino".
4. Guarda como borrador. **No envíes la campaña a revisión** ni la actives sin mi confirmación.
`,
};
